// components/EditableInputField.js
import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

const EditableInputField = ({
  field,
  value,
  label,
  unit = null,
  disabled = false,
  errors = {},
  isAdviceLoading = false,
  selectedTags,
  handleInputChange,
  handleWeightUnitChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="w-full">
      <span className="text-[#414651] text-[14px] sm:text-[16px] block mb-1">
        {label}
      </span>
      <div className="relative border-[none]">
        {field === "targetWeight" ? (
          <div className="relative">
            <TextField
              type="number"
              variant="outlined"
              fullWidth
              size="small"
              value={
                value === null || value === undefined || value === ""
                  ? ""
                  : Math.round(Number(value))
              }
              onChange={(e) => handleInputChange(field, e.target.value, label)}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
              }}
              disabled={disabled || isAdviceLoading}
              sx={{
                "& .MuiOutlinedInput-root": {
                  fontSize: "0.875rem",
                  color: "black",
                  height: "40px",
                  "& fieldset": {
                    borderColor: errors.weight ? "#EF4444" : "#e5e7eb",
                    borderRadius: "0.375rem",
                  },
                  "&:hover fieldset": {
                    borderColor: errors.weight ? "#EF4444" : "#e5e7eb",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: errors.weight ? "#EF4444" : "#e5e7eb",
                    boxShadow: "none",
                    outline: "none",
                    borderWidth: "1px",
                  },
                  "& input::placeholder": {
                    fontSize: "0.9rem",
                    opacity: 1,
                    color: "#9CA3AF",
                  },
                  "&.Mui-disabled": {
                    "& fieldset": {
                      borderColor: "#e5e7eb",
                      outline: "none",
                    },
                    "&:hover fieldset": {
                      borderColor: "#e5e7eb",
                      outline: "none",
                    },
                  },
                },
              }}
              InputProps={{
                endAdornment:
                  field === "targetWeight" ? (
                    <InputAdornment position="end">
                      <div className="flex items-center mr-1">
                        {["kg", "Lbs"].map((unit) => (
                          <button
                            key={unit}
                            onClick={() => handleWeightUnitChange(unit)}
                            className={`px-2 py-0.5 border rounded-md mx-0.5 text-xs ${
                              selectedTags?.targetWeightUnit === unit
                                ? "bg-blue-500 text-white"
                                : "bg-white text-black border-gray-300"
                            }`}
                            type="button"
                            disabled={isAdviceLoading}
                          >
                            {unit}
                          </button>
                        ))}
                      </div>
                    </InputAdornment>
                  ) : unit ? (
                    <InputAdornment position="end">
                      <span className="text-gray-500 text-sm">{unit}</span>
                    </InputAdornment>
                  ) : null,
              }}
              placeholder={label}
            />
          </div>
        ) : (
          <input
            type="number"
            min="1"
            className={`w-full border p-2 rounded-md h-10 text-sm focus:outline-none ${
              errors[field] ? "border-red-500 text-red-500" : "text-black"
            }`}
            value={
              value === null || value === undefined || value === ""
                ? ""
                : Math.round(Number(value))
            }
            onChange={(e) => handleInputChange(field, e.target.value)}
            onKeyDown={(e) => {
              if (["e", "E", "+", "-"].includes(e.key)) {
                e.preventDefault();
              }
            }}
            placeholder={label}
            disabled={isAdviceLoading}
          />
        )}
        {errors[field] && (
          <div className="text-red-500 text-[10px] md:text-[12px] ml-2 mt-1">
            {t("preferences.validation.fieldRequired", {
              field: label,
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default EditableInputField;